// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vG__GxIvY6o89VB8YoQ6 {
  display: flex;
  justify-content: space-between;
  padding: 0 20px !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.03);
  z-index: 99;
  height: 52px !important;
  line-height: 52px !important;
  background-color: #1A8D5F;
}
.kcm3kASCB_xXUx4NXfdu .MINr1Bgr61gzcI3e8tUQ {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/HomeLayout/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,WAAA;EACA,uBAAA;EACA,4BAAA;EACA,yBAAA;AAAF;AAGA;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAFJ","sourcesContent":["\n.header {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 20px !important;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.03);\n  z-index: 99;\n  height: 52px !important;\n  line-height: 52px !important;\n  background-color: #1A8D5F;\n}\n\n.content {\n  .contentChildren {\n    width: 100%;\n    height: 100%;\n    border-radius: 5px;\n    background: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `vG__GxIvY6o89VB8YoQ6`,
	"content": `kcm3kASCB_xXUx4NXfdu`,
	"contentChildren": `MINr1Bgr61gzcI3e8tUQ`
};
export default ___CSS_LOADER_EXPORT___;
